export enum GradeInfoTypes {
    TotalStudent = 0,
    UploadedStudent = 1,
    NotUploadedStudent = 2,
    NotEvaluated = 3
}